<template>
  <div>
    <h3>Cashback</h3>
    <p>CASHBACK is a bonus program offering a refund after a negative series.</p>
    <h5>Terms and conditions</h5>
    <ol>
        <li>The Cashback Bonus is accrued to the account every {{bonus.days}} days.</li>
        <li>It amounts to {{bonus.percent || 0}}% of the amount lost in the previous {{bonus.days}} days.</li>
        <li>Next bonus accrual: {{formatDate(bonus.nextDate)}}.</li>
        <li>When calculating the bonus, only bets made in the "Casino" section of the site are taken into account.</li>
        <li>The rules of the promotion are subject to change.</li>
    </ol>
  </div>
</template>
<script>
  import utils from '../../../../../../../_common/utils'

  export default {
    name: 'bonus-rules-cashback-en',
    props: {
      bonus: {
        type: Object,
        required: true
      }
    },
    methods: {
      formatDate(date) {
        return utils.formatDateTime(date, 'MM/DD HH:mm');
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-cashback/en.vue